import React from "react";
import AppLayout from "@/components/layout/AppLayout";
import ApplicationStatus from "@/components/application/ApplicationStatus";

const ApplicationStatusPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 py-8 md:py-12">
        <h1 className="text-2xl md:text-3xl font-bold mb-6 md:mb-8 text-center text-jungle">
          Application Status
        </h1>
        <ApplicationStatus />
      </div>
    </AppLayout>
  );
};

export default ApplicationStatusPage;
